export const BASE_URL = 'https://api.themoviedb.org/3/search'
export const BASE_IMAGE_URL = 'https://image.tmdb.org/t/p/w500'

//sample request
//https://api.themoviedb.org/3/movie/550?api_key={key}
//search at : https://api.themoviedb.org/3/search/movie?api_key={api_key}&query=Jack+Reacher